import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-diet-meal-item',
  templateUrl: './diet-meal-item.component.html',
  styleUrls: ['./diet-meal-item.component.scss'],
  standalone: false
})
export class DietMealItemComponent implements OnInit, OnDestroy {
  config: any;
  resourceDef: any;
  meal_timing: any = [{ id: "morning", name: "Morning", index: 0 }, { id: "afternoon", name: "Afternoon", index: 1 }, { id: "evening", name: "Evening", index: 2 }]
  dietDetails: any;
  openAccordian: any = { 0: true, 1: false };
  selected_index: any = 0;
  dialogData: any;
  bannerData: any;
  dietMeal: boolean = false;
  currentResource: any = "diet_meal_item_update"
  allDoubleOrder: boolean = false;
  showDoubleOrder: boolean = false;
  wardDoubleOrder: boolean = false;
  private wardLookupDone: boolean = false;
  private subscriptions = new Subscription();
  constructor(
    public baseService: BaseService,
    public alerts: AlertsService,
    public loader: LoaderService,
    public dialogConfig: DialogConfig,
    public dialog: DialogRef,
    public Aroute: ActivatedRoute,
    public router: Router,
    public utilService: UtilService,
    public cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.dialogData = this.dialogConfig.data;
    this.getDoubleOrderConfig();
    if (this.dialogData?.action?.rowClick) { // row click
      this.getRowClickData(this.dialogData?.action, this.dialogConfig.data);
    } else {
      if (this.dialogData && this.dialogData.mealData && this.dialogData.mealData.resource && this.dialogData.mealData.resource.length > 0) {
        this.dietDetails = this.dialogData.mealData;
        this.changedMealData();
      } else {
        if (this.Aroute.snapshot.queryParams.dietmealupdate) {
          this.getBanner();
        } else {
          this.getMealData();
        }
      }
    }
  }

  getBanner() {
    this.bannerData = {
      "jsonName": "appointment_bannerjson",
      "selector": "app-patient-layout",
      "datasource": {
        "application": "diet-kitchen",
        "resource": "diet_planDefinition",
        "query_id": "GET_BY_ID",
      }
    }
    this.dietMeal = true
  }

  previous() {
    this.router.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl);
  }

  patientResult(event: any) {
    let Arr = [];
    Arr.push(event);
    this.dietDetails = { resource: Arr };
    this.changedMealData();
  }

  getMealData() {
    var cardData = sessionStorage.currentData ? JSON.parse(sessionStorage.currentData) : {};
    this.subscriptions.add(this.baseService.get("GET_MEAL_ITEM", `dietId:${this.dialogData.mealId},encounter_id:${cardData.encounter_id},uhId:${cardData.uhId},direct_order:${this.dialogData.direct_order}`, "diet_planDefinition", "diet-kitchen").subscribe((result: any) => {
      if (result.errCode == 0 && result.resource && result.resource.length > 0) {
        this.dietDetails = { resource: [{ "mealDefinition": result.resource }] }
        this.changedMealData();
      } else {
        this.alerts.error(result.error)
      }
    }));
  }

  changedMealData() {
    this.getMealTiming((meal_time_data) => {
      const mealDefinition = this.dietDetails?.resource?.[0]?.mealDefinition;

      if (!mealDefinition || mealDefinition.length === 0) return;

      const timingMap = new Map();
      if (meal_time_data && meal_time_data.length > 0) {
        meal_time_data.forEach(item => {
          timingMap.set(item.mealTimeCode, item.startTime_hrs_mins);
        });
      }

      let mealTiming = mealDefinition.map((meal) => ({
        id: meal.mealTimeCode,
        name: meal.mealTime,
        startTime: timingMap.get(meal.mealTimeCode) || null
      }));

      this.meal_timing = mealTiming.sort((a, b) => a.startTime - b.startTime).map((item, index) => ({ ...item, index }));

      this.syncMasterDoubleOrder();
      this.resolveWardDoubleOrder();

      setTimeout(() => {
        this.meal_timing.forEach((_, index) => {
          this.showHideAccordian(index);
        });
      }, 500);
    });
  }

  getMealTiming(cb: any) {
    let data = {
      "args": `facility_master_type:MEALTIME,status:active`,
      projectionKeys: "id,mealTimeCode,startTime_hrs_mins,facility_id,mealTime"
    }
    this.subscriptions.add(this.baseService.getData(data, ``, "facility_master", "facility-management", "GET_BY_FACILITYMASTERTYPE").subscribe((result: any) => {
      if (result.errCode == 0 && result.resource && result.resource.length > 0) {
        cb(result.resource);
      } else {
        cb([]);
      }
    }));
  }

  getResource() {
    this.baseService.getResourceDef(this.currentResource, (result) => {
      this.config = result.config;
      this.resourceDef = result;
    })
  }

  getConfig(meal_time) {
    if (this.dietDetails.resource[0].mealDefinition && this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition) {
      this.config = Object.assign(this.config, { items: this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition });
    } else {
      this.config = Object.assign(this.config, { items: [] });
    }
    return this.config;
  }

  showHideAccordian(index) {
    this.openAccordian = Object.assign(this.openAccordian, { [index]: true });
    this.getResource();
    this.loader.hideSpinner();
  }

  listen_changes(event, meal_time) {
    if (event && event.selectedItems && event.selectedItems.length > 0) {
      this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition = event.selectedItems;
    } else if (event && event.object && event.object.length > 0) {
      this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition = event.object;

    }

    if (event.type && event.type == "remove_row") {
      this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition.splice(event.index, 1);
    }

    if ((event.type == "dropdown_binded" || event.type == "field_change" || event.type == "searchselect") && event.object != undefined && event.object._manualChange && this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition.length) {
      this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition[event.index] = event.object.value
      if (event.type == "searchselect" && event.editableGrid && event.editableGrid[event.index] && event.editableGrid[event.index].getRawValue() && this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition.filter((item) => item.mealItem == event.editableGrid[event.index].getRawValue().mealItem).length > 1
      ) {
        this.dietDetails.resource[0].mealDefinition.find((meal) => meal.mealTimeCode == meal_time).mealItemsDefinition.splice(event.index, 1);
        event.editableGrid[event.index].controls['mealItem'].setValue("");
        this.alerts.error("Meal Item already added");
        return;
      }
    }
  }

  getDoubleOrderConfig() {
    this.subscriptions.add(this.baseService.get("GET_CONFIG", "module_code:emr,config_code:show_double_diet_order_checkbox", "facility_config_mapping", "facility-management").subscribe((data: any) => {
      this.showDoubleOrder = data.errCode == 0 && data.resource && data.resource.length > 0
        && data.resource[0].config_value != undefined
        && String(data.resource[0].config_value).toLowerCase() == "yes";
      /*WARD LOOKUP ONLY WHEN THE FEATURE IS ON*/
      this.resolveWardDoubleOrder();
    }));
  }

  private resolveWardDoubleOrder() {
    if (!this.showDoubleOrder) {
      return;
    }
    /*MEAL DATA AND THE WARD FLAG ARRIVE INDEPENDENTLY - WHICHEVER LANDS LAST APPLIES THE DEFAULT*/
    if (this.wardLookupDone) {
      this.applyWardDoubleOrder();
      return;
    }
    const wardId = this.dietDetails?.resource?.[0]?.currentWard_id || this.dialogData?.currentWard_id;
    if (!wardId) {
      return;
    }
    this.wardLookupDone = true;
    this.subscriptions.add(this.baseService.get("GET_BY_ID", `id:${wardId}`, "ward", "facility-management").subscribe((result: any) => {
      this.wardDoubleOrder = result.errCode == 0 && result.resource && result.resource.length > 0
        && !!result.resource[0].double_order;
      this.applyWardDoubleOrder();
    }));
  }

  /*ONLY FILL MEAL TIMES THAT WERE NEVER SET, SO A MANUAL UNTICK IS NOT OVERWRITTEN ON REOPEN*/
  private applyWardDoubleOrder() {
    if (!this.wardDoubleOrder) {
      return;
    }
    (this.dietDetails?.resource?.[0]?.mealDefinition || []).forEach((meal) => {
      if (meal.double_order == undefined) {
        meal.double_order = true;
      }
    });
    this.syncMasterDoubleOrder();
  }

  /*CONFIG OFF - STRIP THE FLAG SO THE PAYLOAD IS EXACTLY WHAT IT WAS BEFORE THIS FEATURE,
    EVEN IF THE STORED PLAN STILL CARRIES ONE FROM WHEN THE CONFIG WAS ON*/
  private stripDoubleOrder() {
    (this.dietDetails?.resource?.[0]?.mealDefinition || []).forEach((meal) => {
      delete meal.double_order;
    });
  }

  private mealFor(code) {
    return this.dietDetails?.resource?.[0]?.mealDefinition?.find((meal) => meal.mealTimeCode == code);
  }

  isDoubleOrder(code) {
    return !!this.mealFor(code)?.double_order;
  }

  setDoubleOrder(code, val) {
    const meal = this.mealFor(code);
    if (meal) {
      meal.double_order = !!val;
    }
    this.syncMasterDoubleOrder();
  }

  toggleAllDoubleOrder() {
    (this.dietDetails?.resource?.[0]?.mealDefinition || []).forEach((meal) => {
      meal.double_order = this.allDoubleOrder;
    });
  }

  private syncMasterDoubleOrder() {
    const meals = this.dietDetails?.resource?.[0]?.mealDefinition || [];
    this.allDoubleOrder = meals.length > 0 && meals.every((meal) => !!meal.double_order);
  }

  submitMealItem() {
    if (!this.showDoubleOrder) {
      this.stripDoubleOrder();
    }
    if (this.Aroute.snapshot.queryParams.dietmealupdate) {
      this.submitMealItemUpdate();
    } else if (this.dialogData?.action?.rowClick) {
      this.rowClickSubmitEvent(this.dialogData?.action);
    } else {
      this.dialog.close(this.dietDetails);
    }
  }

  submitMealItemUpdate() {
    this.subscriptions.add(this.baseService.action(this.dietDetails.resource[0], "UPDATE_MEAL_ITEM", "diet-kitchen", "diet_planDefinition").subscribe((result: any) => {
      if (result.errCode == 0) {
        this.alerts.success(result.error);
        this.previous();
      this.dialog.close(this.dietDetails);
      } else {
        this.alerts.error(result.error)
      }
    }));
  }


  getRowClickData(event, items?) {
    let bannerData = event?.banner?.datasource;
    this.loader.showSpinner();
    this.subscriptions.add(this.baseService.get("GET_BY_ID", `id:${items.item.id}`, bannerData.resource, bannerData.application).subscribe((result: any) => {
      if (result.errCode == 0 && result.resource) {
        this.patientResult(result.resource[0]);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  rowClickSubmitEvent(event) {
   let currentUrl = this.router.url;
   this.Aroute.snapshot.queryParams = {...this.Aroute.snapshot.queryParams,returnUrl: currentUrl};
   this.submitMealItemUpdate();
  }
}
